import { writable } from "svelte/store";
export const captureRulesAcceptanceStore = writable(undefined);
